import {
  Autocomplete,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Stack,
  TextField
} from "@mui/material";
import React, { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Swal from "sweetalert2";
import { nbfAddRawMetarial, nbfRawMetarial, nbfSubtractRawMetarial } from "../../api/restApi";
import OverlayLoader from "../../components/modals/OverlayLoader";
import { rawItemsData, setRawItems } from "../../store/reducer/rawItemsSlice";
import { useAppDispatch, useAppSelector } from "../../utils/hooks";
import RawInventoryTable from "./Tables/RawInventoryTable";

  const RawInventory= () => {
    const [createModalOpen, setCreateModalOpen] = useState(false);
    const [subtractModal,setSubtractModal]=useState(false);
    const { rawInventory } = useAppSelector(rawItemsData);
    const product = useSelector((state) => state.rawItems.rawItems);
    console.log(product)
    const [loader,setLoader]=useState(false)
    const dispatch = useAppDispatch();
    useEffect(() => {
      nbfRawMetarialInfo();
    }, []);
    const nbfRawMetarialInfo = async () => {
      try{
        setLoader(true)
        let updatedInventory = await nbfRawMetarial();
        setLoader(false);
        const newUpdatedInventory = product.map((pro) => {
          return {
            ...updatedInventory.find((el) => el.id.toString() === pro.id.toString()),
            ...pro,
            name_english: pro.addItem,
          };
        });      
        // Sort the newUpdatedInventory array by id in ascending order
        newUpdatedInventory.sort((a, b) => a.id - b.id);
        dispatch(setRawItems(newUpdatedInventory));
      }catch{
        console.log("error")
        setLoader(false)
      }   
    };

    const handleAddInventory = async (values) => {
      console.log(values.selectedProduct);
      let title = values.onHand && values.selectedProduct ? `Do you want to add ${values.selectedProduct.name_english} ${values.selectedProduct.name_urdu} ${values.onHand} item` : 
      "Please Select the Inventory and Quantity First!";

      const confirmed = await Swal.fire({
      title: title,
      // icon: "warning",
      showCancelButton: values.onHand && values.selectedProduct ? true : false,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      cancelButtonText:"No",
      confirmButtonText: values.onHand && values.selectedProduct ?  "Yes" : "OK",
    });
    if (confirmed.isConfirmed) {
      try {
        if(values.onHand && values.selectedProduct){
          if (!values || Object.keys(values).length === 0) {
            alert("Please enter valid data");
            return;
          }
          values = {
            ...values,
            timestamp: new Date(),
          };
    
          const id = values.selectedProduct.id;
          const inventoryAdd =await nbfAddRawMetarial({id,quantity:values.onHand});
          
      
          toast.success("Successfully add new item!", {
            position: toast.POSITION.BOTTOM_CENTER,
          });
    
          nbfRawMetarialInfo();
        }else{
          setCreateModalOpen(true);
      }
      } catch (error) {
        console.log(error);
        toast.error("add new item but show in table by refresh!", {
          position: toast.POSITION.BOTTOM_CENTER,
        });
      } 
    }   
    };

    const handleSubtractInventory = async (values) => {
      let title = values.otherUseQuantity && values.selectedProduct ? `Do you want to subtract ${values.selectedProduct.name_english} ${values.selectedProduct.name_urdu} ${values.otherUseQuantity} item` : 
      "Please Select the Inventory and Quanity first!";

      const confirmed = await Swal.fire({
        title: title,
        // icon: "warning",
        showCancelButton: values.otherUseQuantity && values.selectedProduct ? true : false,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText:"No",
        confirmButtonText: values.otherUseQuantity && values.selectedProduct ? "Yes" : "OK",
      });
      if (confirmed.isConfirmed) {
        try {
          if(values.otherUseQuantity && values.selectedProduct){
          if (!values || Object.keys(values).length === 0) {
            alert("Please enter valid data");
            return;
          }
          values = {
            ...values,
            timestamp: new Date(),
          };
          const id = values.selectedProduct.id;
          const inventorySub =await nbfSubtractRawMetarial({id,...values});
          
          toast.success("Successfully subtracted rawInventory!", {
            position: toast.POSITION.BOTTOM_CENTER,
          });
          nbfRawMetarialInfo();
        }else{setSubtractModal(true)}
        } catch (error) {
          console.log(error);
          toast.error("Failed to add new item!", {
            position: toast.POSITION.BOTTOM_CENTER,
          });
        }
      }    
    };
    
    const columns = useMemo(() => [
     {
      accessorKey: "id",
      header: "ID",
      enableColumnOrdering: false,
      enableEditing: false, //disable editing on this column
      enableSorting: false,
      size: 80,
    },
      {
        accessorKey: "name_english",
        header: "Name_Item",
        size: 80,
      },
      {
        accessorKey: "onHand",
        header: " Onhand",
        size: 80,
      },
      {
        accessorKey: "production",
        header: "Todays    Quantity",
        size: 80,
      },

    ]);
    return (
      <>
        <div>
        <Box sx={{ flexGrow: 0,  }}>
            <Grid item xs={12} md={12}>
        <Stack spacing={3} marginX={3} mt={1}>
          <RawInventoryTable
            setCreateModalOpen={setCreateModalOpen}
            setSubtractModalOpen={setSubtractModal}
            tableData={rawInventory}
            columns={columns}
          ></RawInventoryTable>
        </Stack>
      </Grid>
      </Box>
    </div>
        <AddInventoryModal
          columns={columns}
          open={createModalOpen}
          onClose={() => setCreateModalOpen(false)}
          onSubmit={handleAddInventory}
        />
        <SubtractInventoryModal
          columns={columns}
          open={subtractModal}
          onClose={() => setSubtractModal(false)}
          onSubmit={handleSubtractInventory}
        />
        <OverlayLoader open={loader} />
      </>
 
    );
  };
  
  //example of creating a mui dialog modal for creating new rows
  

  export const AddInventoryModal = ({ open, columns, onClose, onSubmit }) => {
    const product = useSelector((state) => state.rawItems.rawItems);
    console.log(product)
    const initialValues = {
      selectedProduct: '',
      onHand: '',
      price: '',
    };
    const [values, setValues] = useState(initialValues);
    const [productsOption, setProductsOption] = useState([]);
  
    useEffect(() => {
      setProductsOption(
        product.map((data) => ({
          ...data,
          label: data.addItem
        }))
      );
    }, [product]);
  
    const handleSelectProduct = (event, newValue) => {
      setValues({ ...values, selectedProduct: newValue });
    };
  
    const handleKeyDown = (e) => {
      if (e.key === 'ArrowRight') {
        e.preventDefault();
        if (document.activeElement.id === 'product-input') {
          document.getElementById('quantity-input').focus();
        } else if (document.activeElement.id === 'quantity-input') {
          document.getElementById('cancel-button').focus();
        } else if (document.activeElement.id === 'cancel-button') {
          document.getElementById('save-button').focus();
        } else if (document.activeElement.id === 'save-button') {
          document.getElementById('save-close').focus();
        }else if (document.activeElement.id === 'save-close') {
          document.getElementById('product-input').focus();
        }
      } else if (e.key === 'ArrowLeft') {
        e.preventDefault();
        if (document.activeElement.id === 'product-input') {
          document.getElementById('save-close').focus();
        } else if (document.activeElement.id === 'save-close') {
          document.getElementById('save-button').focus();
        } else if (document.activeElement.id === 'save-button') {
          document.getElementById('cancel-button').focus();
        } else if (document.activeElement.id === 'cancel-button') {
          document.getElementById('quantity-input').focus();
        } else if (document.activeElement.id === 'quantity-input') {
          document.getElementById('product-input').focus();
        }
      }
    };
    
    
    
  
    const handleSubmitClose = async () => {
      onSubmit(values);
      setValues(initialValues);
      onClose();
    };
  
    const handleSubmit = async () => {
      onSubmit(values);
      setValues(initialValues);
    };
  
    return (
      <Dialog open={open} size="lg" style={{ zIndex: 900 }}>
        <DialogTitle textAlign="center">Add Raw Inventory</DialogTitle>
        <form onSubmit={(e) => e.preventDefault()} onKeyDown={handleKeyDown}>
        <DialogContent>
          
            <Stack
              sx={{
                width: '90%',
                minWidth: { xs: '300px', sm: '360px', md: '400px' },
                gap: '1.5rem',
              }}
            >
              <Box>
                <Autocomplete
                  id="product-input"
                  disablePortal
                  label="Select item"
                  options={productsOption}
                  sx={{
                    minWidth: 300,
                    marginTop: '16px',
                    display: 'flex',
                    justifyContent: 'center',
                  }}
                  value={values.selectedProduct || null}
                  onChange={handleSelectProduct}
                  renderInput={(params) => <TextField {...params} label="Select_Item" />}
                />
              </Box>
              <Box>
                <TextField
                  id="quantity-input"
                  sx={{ minWidth: '100%', marginTop: '10px' }}
                  type="number"
                  label="Enter quantity"
                  value={values.onHand || ''}
                  onChange={(e) => {
                    const inputValue = e.target.value.trim();
                    if (/^\d*\.?\d*$/.test(inputValue)) {
                      setValues({ ...values, onHand: inputValue });
                    }
                  }}
                  onKeyPress={(e) => {
                    if (e.key === '-') {
                      e.preventDefault();
                    }
                  }}
                />
              </Box>

            </Stack>
          
        </DialogContent>
        <Stack sx={{ p: '1.25rem' }} justifyContent="center" direction="row" spacing={1}>
          <Button
            id="cancel-button"
            onClick={onClose}
            variant="contained"
          >
            Cancel
          </Button>
          <Button
            id="save-button"
            color="secondary"
            onClick={handleSubmit}
            variant="contained"
          >
            Save
          </Button>
          <Button
            id="save-close"
            color="secondary"
            onClick={handleSubmitClose}
            variant="contained"
          >
            Save & Close
          </Button>
        </Stack>
        </form>
      </Dialog>
    );
  };
  
//************ SubtractInventoryModal**************///

  export const SubtractInventoryModal = ({ open, columns,onClose, onSubmit }) => {
    const product = useSelector((state) => state.products.products);

    const initialValues = {
      selectedProduct: "",
      useType: "",
      useDetail:'',
      otherUseQuantity:'',
      
    };
    const [values, setValues] = useState(initialValues);
    const [productsOption, setProductsOption] = useState([]);
    
    const wastageType=['Wastage','Staff','Guest'];

    const handleSubtract = async () => {
      onSubmit(values);
      setValues(initialValues)
    };
    const handleSubtractClose = async () => {
      onSubmit(values);
      setValues(initialValues)
      onClose();
    };

    useEffect(() => {
      setProductsOption([
        ...product.map((data) => {
          data = {
            ...data,
            label: data.name_english + " " + data.name_urdu,
          };
          return data;
        }),
      ]);
    }, [product]);
    
    const handleSelectProduct = async (event, newValue) => {
      setValues({ ...values, selectedProduct: newValue });  
    };
    const handleSelectType = async (event, newValue) => {
      setValues({ ...values, useType: newValue });
    };

    const handleKeyDown = (e) => {
      if (e.key === 'ArrowRight') {
        e.preventDefault();
        if (document.activeElement.id === 'product-input') {
          document.getElementById('quantity-input').focus();
        }
        else if (document.activeElement.id === 'quantity-input') {
          document.getElementById('waste-type').focus();
        }else if (document.activeElement.id === 'waste-type') {
          document.getElementById('waste-detail').focus();
        } else if (document.activeElement.id === 'waste-detail') {
          document.getElementById('cancel-button').focus();
        } else if (document.activeElement.id === 'cancel-button') {
          document.getElementById('save-button').focus();
        } else if (document.activeElement.id === 'save-button') {
          document.getElementById('save-close').focus();
        }else if (document.activeElement.id === 'save-close') {
          document.getElementById('product-input').focus();
        }
      } else if (e.key === 'ArrowLeft') {
        e.preventDefault();
        if (document.activeElement.id === 'product-input') {
          document.getElementById('save-close').focus();
        } else if (document.activeElement.id === 'save-close') {
          document.getElementById('save-button').focus();
        } else if (document.activeElement.id === 'save-button') {
          document.getElementById('cancel-button').focus();
        } else if (document.activeElement.id === 'cancel-button') {
          document.getElementById('waste-detail').focus();
        } else if (document.activeElement.id === 'waste-detail') {
          document.getElementById('waste-type').focus();
        }else if (document.activeElement.id === 'waste-type') {
          document.getElementById('quantity-input').focus();
        }else if (document.activeElement.id === 'quantity-input') {
          document.getElementById('product-input').focus();
        }
      }
    };
    
  
    return (
      <Dialog open={open} size="lg" style={{ zIndex: 900 }}>
        <DialogTitle textAlign="center">Subtract Inventory</DialogTitle>
        <form onSubmit={(e) => e.preventDefault()} onKeyDown={handleKeyDown}>
        <DialogContent>
            <Stack
              sx={{
                width: "100%",
                minWidth: { xs: "300px", sm: "360px", md: "400px" },
                gap: "1.5rem",
              }}
            >
              <Box>
                  <Autocomplete
                    disablePortal
                    label="Select Product"
                    id="product-input"
                    options={productsOption}
                    sx={{
                      minWidth: 300,
                      marginTop: "16px",
                      display: "flex",
                      justifyContent: "center",
                    }}
                    value={values.selectedProduct || null}
                    onChange={handleSelectProduct}
                    renderInput={(params) => (
                      <TextField {...params} label="Product" />
                    )}
                  />
              </Box>
            <Box>
              <TextField
              id="quantity-input"
                sx={{ minWidth: "100%", marginTop: "10px" }}
                type="number"
                label="Enter quantity"
                value={values.otherUseQuantity ||''}
                onChange={(e) => {
                  const inputValue = e.target.value.trim();
                  if (/^\d*\.?\d*$/.test(inputValue)) {
                    setValues({ ...values, otherUseQuantity: inputValue });
                  }
                }}
                onKeyPress={(e) => {
                  if (e.key === "-") {
                    e.preventDefault();
                  }
                }}
              />
            </Box>
              <Box>
                  <Autocomplete
                    disablePortal
                    label="Select Product"
                    id="waste-type"
                    options={wastageType}
                    sx={{
                      minWidth: 300,
                      marginTop: "16px",
                      display: "flex",
                      justifyContent: "center",
                    }}
                    value={values.useType || null}
                    onChange={handleSelectType}
                    renderInput={(params) => (
                      <TextField {...params} label="Type" />
                    )}
                  />
              </Box>
              <Box>
                  <TextField
                  id="waste-detail"
                    sx={{ minWidth: "100%", marginTop: "10px" }}
                    type="text"
                    label="Use Detail"
                    value={values.useDetail}
                    onChange={(e) =>
                      setValues({ ...values, useDetail:e.target.value })
                    }
                  />
              </Box>
            </Stack>
        </DialogContent>
          
        <Stack sx={{ p: "1.25rem" }} justifyContent='center' direction='row' spacing={1}>
          <Button id="cancel-button" onClick={onClose} variant="contained">Cancel</Button>
          <Button id="save-button" color="secondary" onClick={handleSubtract} variant="contained">
            Save
          </Button>
          <Button id="save-close" color="secondary" onClick={handleSubtractClose} variant="contained">
            Save & Close
          </Button>
        </Stack>
        </form>
      </Dialog>
    );
  };
  export default RawInventory;
  